import { InjectionToken } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';

export * from './date.utils';
export * from './error.utis';
export * from './string.utils';
export * from './array.utils';

export const overlayRefToken = new InjectionToken<OverlayRef>('OVERLAY_REF');
